import { render, staticRenderFns } from "./cityAreaList.vue?vue&type=template&id=1ade2e58&scoped=true"
import script from "./cityAreaList.vue?vue&type=script&lang=js"
export * from "./cityAreaList.vue?vue&type=script&lang=js"
import style0 from "./cityAreaList.vue?vue&type=style&index=0&id=1ade2e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade2e58",
  null
  
)

export default component.exports